var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingbag1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2514_43004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5578 11.8491H3.79176L2.31378 37.1497C2.19866 39.1197 2.88106 40.9951 4.23501 42.4305C5.58904 43.866 7.42149 44.6565 9.39475 44.6565H27.834L34.4794 27.6256L33.5578 11.8491Z",
    fill: "#FFDE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4794 27.6256L33.5578 11.8491H18.6748V44.6565H27.834L34.4794 27.6256Z",
    fill: "#FFB655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9033 18.1853H24.0908V9.13478C24.0908 6.14838 21.6612 3.71875 18.6748 3.71875C15.6884 3.71875 13.2587 6.14838 13.2587 9.13478V18.1852H10.4462V9.13478C10.4461 4.59756 14.1375 0.90625 18.6748 0.90625C23.2121 0.90625 26.9033 4.59756 26.9033 9.13478V18.1853Z",
    fill: "#495959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6748 0.90625V3.71875C21.6612 3.71875 24.0908 6.14838 24.0908 9.13478V18.1852H26.9033V9.13478C26.9033 4.59756 23.212 0.90625 18.6748 0.90625Z",
    fill: "#323C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3032 45.5179C47.8179 41.0032 47.8179 33.6833 43.3032 29.1686C38.7884 24.6539 31.4686 24.6539 26.9538 29.1686C22.4391 33.6833 22.4391 41.0032 26.9538 45.5179C31.4686 50.0327 38.7884 50.0327 43.3032 45.5179Z",
    fill: "#00CC76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1361 25.7812V48.9063C41.5118 48.9063 46.6987 43.7194 46.6987 37.3438C46.6987 30.9682 41.5118 25.7812 35.1361 25.7812Z",
    fill: "#009986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6062 42.5122L29.0382 37.3458L31.1452 35.4828L33.6968 38.3689L38.9813 32.895L41.0047 34.8484L33.6062 42.5122Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9814 32.895L35.1361 36.878V40.9273L41.0048 34.8484L38.9814 32.895Z",
    fill: "#E1EBF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2514_43004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.90625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingbag1);
export default __webpack_public_path__ + "static/media/shoppingbag-1.87186244d805023446efac6449e78548.svg";
export { ForwardRef as ReactComponent };